import styled from 'styled-components';
import {
    space,
    layout,
    typography,
    color,
    border,
    position,
    SpaceProps,
    LayoutProps,
    TypographyProps,
    ColorProps,
    BorderProps,
    PositionProps,
} from 'styled-system';
import { StyledTD } from '../td/styles';

type Props = SpaceProps & LayoutProps & TypographyProps & ColorProps & BorderProps & PositionProps;

export const StyledTFoot = styled.tfoot<Props>`
    color: ${({ theme }) => theme.colors.secondaryText};
    font-weight: ${({ theme }) => theme.fontWeights.medium};

    ${space}
    ${layout}
  ${typography}
  ${color}
  ${border}
  ${position}

  ${StyledTD} {
        padding: ${({ theme }) => theme.space[5]} ${({ theme }) => theme.space[4]};
        color: ${({ theme }) => theme.colors.table.footer.text};
        background-color: ${({ theme }) => theme.colors.table.footer.background};
        font-weight: ${({ theme }) => theme.fontWeights.medium};
    }
`;
